// Cliente de casa del superadmin y responsable por defecto del cliente.
// El superadmin con tenant sigue eligiendo el cliente activo en el switcher.

export interface SessionUser {
  role?: string;
  tenant?: string | null;
}

export function selectedTenantForSession(
  user: SessionUser | null | undefined,
  storedTenantId: string | null,
): string | null {
  if (!user) return null;
  if (user.role === 'superadmin') return storedTenantId;
  return user.tenant || null;
}

export function readDefaultAssigneeId(settings: Record<string, unknown> | undefined): string {
  const id = settings?.default_assignee;
  return typeof id === 'string' ? id.trim() : '';
}

export function writeDefaultAssigneeSettings(
  settings: Record<string, unknown> | undefined,
  userId: string,
): Record<string, unknown> {
  const base = { ...(settings ?? {}) };
  const id = userId.trim();
  if (id) base.default_assignee = id;
  else delete base.default_assignee;
  return base;
}

export function assigneeOptionLabel(
  user:
    | {
        display_name?: string;
        name?: string;
        email?: string;
        role?: string;
      }
    | null
    | undefined,
): string {
  if (!user) return '—';
  const name = user.display_name || user.name || user.email || '—';
  return user.role === 'superadmin' ? `${name} (superadmin)` : name;
}
